import { join, trim } from 'es-toolkit/compat';

import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  locationName?: string;
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

class Address extends BaseComponent<Props> {
  render() {
    const { locationName, address, address2, city, state, zipCode } = this.props;

    const cityStateZip = trim(join([city ? city + ',' : '', state, zipCode], ' '));

    return (
      <div>
        {locationName && <div>{locationName}</div>}

        {address && <div>{address}</div>}

        {address2 && <div>{address2}</div>}

        {cityStateZip && <div>{cityStateZip}</div>}
      </div>
    );
  }
}

export default Address;
